import { IconDefinition } from "@fortawesome/fontawesome-svg-core"

import { faIcon } from "@utils/faIcon"

import { objectMap } from "@constants/objectMap"

import { ClientAvatarType, ObjectAvatarProps } from "./ObjectAvatar.types"

// Narrow the props union to the listed object types so a prop only declared on some of them is safe to read.
export function hasObjectType<Type extends ObjectAvatarProps["objectType"]>(
    props: ObjectAvatarProps,
    ...types: Type[]
): props is Extract<ObjectAvatarProps, { objectType: Type }> {
    return (types as ObjectAvatarProps["objectType"][]).includes(props.objectType)
}

// Business clients carry the client object icon; individuals read as a person
export const clientAvatarIcons: Record<ClientAvatarType, IconDefinition> = {
    business: objectMap.client.iconActive,
    individual: faIcon({ name: "user", style: "solid" }),
}
